import { render } from "./General.vue?vue&type=template&id=37eb6cd4&scoped=true"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"

import "./General.vue?vue&type=style&index=0&id=37eb6cd4&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37eb6cd4"]])

export default __exports__